module.exports = __webpack_public_path__ + "img/list_bg@2x.e21b6849.png";